import { useStaticQuery } from 'gatsby'
import React from 'react'
import { Helmet } from 'react-helmet'
import GlobalStyles from '../styles/GlobalStyles'
import Footer from './Footer'
import Nav from './Nav'

// function CheckHeader({ student }) {
//   if (student.first_name > 0) {
//     return (
//       <Helmet>
//         <title>
//           CCA MFA 2021 | {student.first_name}
//         </title>
//         <meta name="description" content="Helmet application" />
//       </Helmet>
//     )
//   }
// 	else {
// 		<Helmet>
//         <title>
//           CCA MFA 2021
//         </title>
//         <meta name="description" content="Helmet application" />
//       </Helmet>
// 	}
// }

export default function Layout ({ students, children }) {
  const data = useStaticQuery(graphql`
    query {
      homepage: sanityHomepage {
        _id
        background_color {
          hex
        }
        text_color {
          hex
        }
      }
      social: allSanityHomepage {
        nodes {
          social_links {
            _key
            link_text
            url
          }
        }
      }
    }
  `)

  const backgroundColor = data.homepage.background_color.hex
  const textColor = data.homepage.text_color.hex

  const socialLinks = data.social.nodes

  return (
    <>
      {/* <CheckHeader student={student}></CheckHeader> */}
      <GlobalStyles backgroundColor={backgroundColor} textColor={textColor} />
      {/* <Nav students = {students} /> */}
      {children}
      <Footer social={socialLinks}></Footer>
    </>
  )
}
